module.exports = __webpack_public_path__ + "static/media/bluePlus.5e9766db.svg";